import currencyData from "constants/currencyConstants";
import { Pricing } from "./types";
import urlBuilder from "@Utils/urlBuilder";

const getAvailableStartingPricingHelper = (pricingObject: any) => {
  if (pricingObject?.min_available_price) {
    return pricingObject.min_available_price;
  }
  if (pricingObject?.available_price) {
    return pricingObject.available_price;
  }
  if (pricingObject?.min_price) {
    return pricingObject.min_price;
  }
  if (pricingObject?.max_price) {
    return pricingObject.max_price;
  }
  return pricingObject?.price;
};
export const getPricingCurrency = (currency: any) => {
  const finalCurrencyObject = currencyData.find(
    (currencyObject) =>
      currencyObject?.short_name?.toLocaleLowerCase() == currency?.toLocaleLowerCase() ||
      currencyObject?.standard_name?.toLocaleLowerCase() == currency?.toLocaleLowerCase(),
  );
  if (finalCurrencyObject) {
    return finalCurrencyObject.symbol;
  }
  return "£";
};

export const getFormattedPricingPostConfirmation = (rent: any, isStartingPrice: boolean) => {
  const currency = getPricingCurrency(rent?.currency);
  const price = rent?.amount;
  return isStartingPrice ? `Starting from ${currency}${price}` : `${currency}${price}`;
};

export const getFormattedPricing = (pricing: Pricing, isStartingPrice: boolean) => {
  const currency = getPricingCurrency(pricing.currency);
  const minPrice = getAvailableStartingPricingHelper(pricing);
  const price = pricing?.price ?? minPrice;

  return isStartingPrice ? `Starting from ${currency}${price}` : `${currency}${price}`;
};

export const isPaymentActive = (inventory: any) => {
  let flag = isAvailable(inventory);
  if (inventory.meta?.payment == false) {
    flag = false;
  }
  return flag;
};

const isAvailable = (data: any) => {
  let flag = true;
  // Either if tag is mentioned
  if (data?.tags) {
    data.tags?.forEach((tag: any) => {
      if (tag == "not_available") {
        flag = false;
      }
    });
  }

  // if inventory is not available
  if (data?.available === false) {
    flag = false;
  }

  // Otherwise if its inactive (only for parent)
  if (data?.parent_id == null && data?.status == "inactive") {
    flag = false;
  }
  return flag;
};

export const getPaymentFullUrl = (inventory: any, params = {}) => {
  const canonicalName = inventory.canonical_name;
  const path = `/places/${canonicalName}/payment`;
  return urlBuilder(path, { params });
};

export const getPricingDuration = (duration: string) => {
  let durationFormatted = null;
  switch (duration) {
    case "weekly":
      durationFormatted = "week";
      break;
    case "monthly":
      durationFormatted = "month";
      break;
    default:
      duration = "";
  }
  return durationFormatted;
};
